// Level of a section against its recommended range: sections.level_status ("low", "recommended", "high" or "unknown"),
// written by the gauge Cloud Function. The brand calls them bas / bon / haut (docs/BRAND.md).
const KEYS = { low: "low", recommended: "good", high: "high" };

const LABELS = { low: "Niveau bas", good: "Niveau bon", high: "Niveau haut" };

// "low", "good", "high", or null when the level is unknown
export function levelKey(status) {
  return KEYS[status] || null;
}

export function levelLabel(status) {
  const key = levelKey(status);
  return key ? LABELS[key] : "";
}

// Text colour class of the current flow (theme colours level-low / level-good / level-high)
export function levelTextClass(status) {
  const key = levelKey(status);
  return key ? `text-level-${key}` : "";
}
